"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AbortionInfoForm_1 = __importDefault(require("../component/AbortionInfoForm"));
;
var AbortionInformation = /** @class */ (function (_super) {
    __extends(AbortionInformation, _super);
    function AbortionInformation(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        return _this;
    }
    AbortionInformation.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    AbortionInformation.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    AbortionInformation.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "form__section" },
            react_1.default.createElement("h2", { className: "heading02" }, "\u6D41\u7523\u306E\u60C5\u5831"),
            react_1.default.createElement(AbortionInfoForm_1.default, null)));
    };
    return AbortionInformation;
}(react_1.Component));
exports.default = AbortionInformation;
